/**
 * This component allows for a customer to assent to a transfer

 */
import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Typography } from '@mui/material';
import { Avatar, List, ListItem, ListItemText, ListItemAvatar } from '@mui/material';

import Add from '@mui/icons-material/Add';
import ReportProblem from '@mui/icons-material/ReportProblem';

import AbEnvironment from '../auth/AbEnvironment';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

import SavingSpinner from '../ui/SavingSpinner';
import AppBindStyles from '../../AppBindStyles';
import ConfirmationDialog from '../ui/ConfirmationDialog';

import PaymentFormII from '../paymentsources/PaymentFormII';
import ACHFormII from '../paymentsources/ACHFormII';
import PaymentSourceDialog from '../ui/PaymentSourceDialog';
import PageTitle from '../ui/PageTitle';


import { yellow } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();

const TransferAssentQuery = graphql`
query TransferAssentQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    parentId
    customerStatus
    xferAssentBy
    xferAssentDate
    paymentSourceTsByAccountId {
      totalCount
    }

    accountTByParentId {
      accountName
      contactEmail
    }
    customerAppTsByCustomerAccountId { 
      totalCount 
      nodes { 
        appStatus
        appTByAppId { 
          appName 
          appSku
          appLogo
        }
      }
    }
  }
}
`;

const styles = theme => ({
  root: {
    width: '100%',
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 980,
    marginTop: 16
  },
  paperFundingSource: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 980

  }
});

class TransferAssent extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      showSpinner: false,
      showSpinnerCancel: false,
      forceFetch: 0,
      saveStatus: null,
      saveMessage: null,
      saveSnackbarOpen: false,
      saveSnackbarDuration: null,

      confirmAssent: false,
      nextStep: false,
      cancelAssent: false,

      showACHSpinner: false,
      achOpen: false,
      ccOpen: false,
      showCCSpinner: false
  
     };
  }

  componentDidMount() {

  }

  showSpinner() {
    return this.state.showSpinner;
  }

  showSpinnerCancel() {
    return this.state.showSpinnerCancel;
  }
 
  
  render() {
    const { isAuthenticated, isAuthenticatedCustomer, isUnauthenticatedCustomer, logError } = this.props.auth;
    const { classes } = this.props;
    const yellowColor = yellow[600];

    if (!isAuthenticated()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedCustomer() || isUnauthenticatedCustomer()) {
 
        let accountId = abEnvironment.getUserAttribute("a_id");


        return (
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={TransferAssentQuery}
            variables={{accountId: accountId, forceFetch: this.state.forceFetch}}
            render={({error, props})=> {

              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
  
                let wrongState =  false;
                if (props.accountTByAccountId.xferAssentBy) {
                  wrongState = true;
                }
                if (props.accountTByAccountId.customerStatus === 0) {
                  wrongState = true;
                }
                if (props.accountTByAccountId.customerStatus === 2) {
                  wrongState = true;
                }

                if (this.state.nextStep === true) {
                  //this allows for a popup dialog before they are logged out.
                  wrongState = false;
                }

                let resellerId = props.accountTByAccountId.parentId;
                let resellerName = props.accountTByAccountId.accountTByParentId.accountName;
                let resellerEmail = props.accountTByAccountId.accountTByParentId.contactEmail;
                let appCounter = 0;

                let hasFundingSource = false;
                if (props.accountTByAccountId.paymentSourceTsByAccountId.totalCount > 0) {
                  hasFundingSource = true;
                }

                let activeSubscriptions = [];
                let i = 0;
                for (i = 0; i < props.accountTByAccountId.customerAppTsByCustomerAccountId.nodes.length; i++) {
                  let sub = props.accountTByAccountId.customerAppTsByCustomerAccountId.nodes[i];
                  if (sub.appStatus !== 2) {
                    activeSubscriptions.push(sub);
                  }
                }

                let uInfo = abEnvironment.getAccountContact();

                let achButtonVariant     = 'outlined';
                let ccButtonVariant      = 'outlined';
            
                let showAchButton = false;
                if (this.isACHAllowed(uInfo)) {
                  showAchButton = true;
                  achButtonVariant = 'contained';
                } else {
                  ccButtonVariant = 'contained';
                }

                if (wrongState) {
                  
                  return (
                    <Redirect to='/home' />
                  )

                } else {
                  return (
                    <div>
                      <PageTitle title="Transfer subscriptions" subtitle="Take direct control of your subscriptions." />
                      <Paper className={classes.paper}>
  
                      <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                          <Grid item xs={12}>
                            <Typography variant="h6">Confirm transfer of subscription</Typography>
                          </Grid>
                          {(resellerName !== 'AppBind') &&
                          <React.Fragment>
                          <Grid item xs={12} style={{marginTop: '-16px'}}>
                            <Typography variant="body2">{resellerName + ' would like to transfer your subscriptions to your control, to be directly managed by you.'}</Typography>
                          </Grid>
  
                          <Grid item xs={12}>
                            <List className={classes.root}  subheader={<li />}>
                              <ul >
                              {activeSubscriptions.map(app => {
                                  return (
                                      <ListItem key={`item-${appCounter++}`}>
                                        <ListItemAvatar>
                                          <Avatar style={{marginRight: '16px'}} alt={app.appTByAppId.appName} src={app.appTByAppId.appLogo} />
                                        </ListItemAvatar>
                                        <ListItemText primary={app.appTByAppId.appName} />
                                      </ListItem>
                              )})}
                              </ul>
                            </List>
                          </Grid>
                          </React.Fragment>
                          }
  
                          {!hasFundingSource &&
                          <Paper  className={classes.paperFundingSource}>
                            <Grid container spacing={0} direction="column" justifyContent="flex-start">
                              <Grid item xs={12} style={{display:"flex"}}>
                                <ReportProblem htmlColor={yellowColor} style={{marginTop: '2px', marginRight: '8px'}}/>
                                <Typography variant="h6">Connect your funding source</Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2">Before starting the transfer, we need you to add your funding source to take over billing for these apps.</Typography>
                              </Grid>
                            </Grid>
  
                            <Grid container spacing={2} justifyContent="flex-start" style={{marginTop: '16px'}}>
                            {!this.state.showCCSpinner &&
                            <Grid item > 
                              <Button color="primary" 
                                      variant={ccButtonVariant}
                                      onClick={() => { this.openCCDialog();}}>
                                <Add/> Add Credit Card
                              </Button>
  
                            </Grid>
                            }
                            {this.state.showCCSpinner &&
                            <Grid item > 
                              <Button disabled={false} color="primary" variant={ccButtonVariant} >
                                <SavingSpinner/>
                              </Button>
                            </Grid>
                            }
                            {showAchButton && !this.state.showACHSpinner &&
                            <Grid item > 
                              <Button color="primary" 
                                      variant={achButtonVariant}
                                      onClick={() => { this.openACHDialog();}}>
                                  <Add/> Add US Bank Account (ACH)
                              </Button>
                            </Grid>
                            }
                            {showAchButton && this.state.showACHSpinner &&
                            <Grid item > 
                              <Button disabled={false} color="primary" variant={achButtonVariant} >
                                <SavingSpinner/>
                              </Button>
                            </Grid>
                            }
                            </Grid>
  
                          </Paper>
                          }
                          
                          <Grid container spacing={0} justifyContent="flex-start">
                          <Grid item>
                            {!this.showSpinner() &&
                              <Button disabled={wrongState || !hasFundingSource} color="primary" style={AppBindStyles.bottomButton}
                                      variant="contained" onClick={() => {this.transferAssent(resellerId); }}>
                              Confirm transfer
                            </Button> }
                            {this.showSpinner() &&
                              <Button color="primary" variant="contained" style={AppBindStyles.bottomButton}>
                                <SavingSpinner/></Button>
                            }
    
                          </Grid>
                          <Grid item>
                            {!this.showSpinnerCancel() &&
                              <Button disabled={wrongState} color="primary" style={AppBindStyles.bottomButton}
                                      variant="outlined" onClick={() => {this.setState({cancelAssent:true}); }}>
                              Decline Transfer
                            </Button> }
                            {this.showSpinnerCancel() &&
                              <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}>
                                <SavingSpinner/></Button>
                            }
    
                          </Grid>
                        </Grid>
                        <Dialog
                          disableEscapeKeyDown
                          open={this.state.nextStep}
                          onClose={(event, reason) => { if (reason !== 'backdropClick') { this.finishAssent();}}}
                          maxWidth="xs"
                        >
                          <DialogTitle id="confirmation-dialog-title">Transfer confirmed</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Your account transfer has been processed.  If you haven't already set a password for your account, please check your email for password reset instructions.
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            
                            <Button onClick={() => { this.finishAssent();}} color="primary" variant="contained">
                              {'Ok' }
                            </Button>
                          </DialogActions>
                      </Dialog>
    
                        <ConfirmationDialog
                            open={this.state.cancelAssent}
                            onClose={() => { this.setState({cancelAssent:false});}}
                            onConfirm={() => { this.cancelAssent(resellerId); }}
                            onCancel={() => { }}
                            title="Decline transfer"
                            cancelBtn="Cancel"
                            okBtn="Yes, decline to transfer"
                            irreversibleAction={true}
                          >
                                                  
                            <Typography style={{marginBottom: '16px'}}>
                              {'We will notify ' + resellerName +  ' that you decline to transfer your subscriptions.'}
                            </Typography>
                            
                            They may choose to stop paying for or cancel your subscriptions. Please contact <a href={"mailto:" + resellerEmail}>{resellerEmail}</a> if another action must be taken.
                        </ConfirmationDialog>  
  
  
                        </Grid>
  
  
                      <PaymentSourceDialog
                        title="Add credit card"
                        open={this.state.ccOpen}
                        onClose={this.handleCCClose} >
                            <PaymentFormII pcId={uInfo.stripeCid} 
                                        dAccountId={uInfo.accountId}
                                        dAccountName={uInfo.accountName}
                                        dFirstName={uInfo.firstName}
                                        dLastName={uInfo.lastName}
                                        dEmail={uInfo.email}
                                        dPhone={uInfo.phone}
                                        dAddress1={uInfo.address1}
                                        dAddress2={uInfo.address2}
                                        dCity={uInfo.city}
                                        dState={uInfo.state}
                                        dCountry={uInfo.country}
                                        dPostalCode={uInfo.postalCode}
                                        auth={this.props.auth}
                                        porder={0}
                                        setStripeCid={this.setStripeCidOnUInfo}
                                        history={this.props.history}
                                        onClose={this.handleCCClose}
                            />
                       </PaymentSourceDialog>

                      {(uInfo.achActive === "1" || uInfo.achActive === "2") && this.state.achOpen &&
                      <PaymentSourceDialog
                        title="Add US Bank Account (ACH)"
                        open={this.state.achOpen}
                        onClose={this.handleACHClose} >
                        <ACHFormII pcId={uInfo.dwollaCid} 
                                dAccountId={uInfo.accountId}
                                dAccountName={uInfo.accountName}
                                dFirstName={uInfo.firstName}
                                dLastName={uInfo.lastName}
                                dEmail={uInfo.email}
                                dPhone={uInfo.phone}
                                dAddress1={uInfo.address1}
                                dAddress2={uInfo.address2}
                                dCity={uInfo.city}
                                dState={uInfo.state}
                                dCountry={uInfo.country}
                                auth={this.props.auth}
                                porder={0}
                                setDwollaCidOnUInfo={this.setDwollaCidOnUInfo}
                                history={this.props.history}
                                onClose={this.handleACHClose}
                                />
                      </PaymentSourceDialog>
                      }
                    </Paper>
    
                    </div>
                  )
  
                }

                
              }
              return <LoadingSpinner />;
            }      
          }
          />
        );

    } else {
      return (
        <Redirect to='/home' />
      );
    }    
  }

  transferAssent(resellerId) {


    this.setState({ showSpinner: true });
    let forceFetch = this.state.forceFetch;
    forceFetch++;

    const { callPartnerApi } = this.props.auth;

    let acctId = abEnvironment.getUserAttribute("a_id");
    let userId = abEnvironment.getUserAttribute("u_id");

    let aPjwt = abEnvironment.getPjwt();
    

    let payload = {
      operation: "confirmCustomerTransfer",
      params: {
        pJwt: aPjwt,
        resellerAccountId: resellerId,
        customerAccountId: acctId,
        userId: userId
      }
    }
      
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then((response) => {
      return response.json();
    })
    .then(response => {
      // console.log('Account updated')
      this.setState({ forceFetch: forceFetch, nextStep: true, showSpinner: false });
    })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({ forceFetch: forceFetch, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Update failed.', saveSnackbarDuration: null });
    });
  }

  finishAssent() {

    //
    // we log the user out as otherside the state is invalid (wrong role, etc).
    //once a user has been transfered, they need to set up their password and log in as resellers.
    this.props.auth.logout();

  }

  cancelAssent(resellerId) {


    this.setState({ showSpinnerCancel: true });
    let forceFetch = this.state.forceFetch;
    forceFetch++;

    const { callPartnerApi } = this.props.auth;

    let acctId = abEnvironment.getUserAttribute("a_id");

    let aPjwt = abEnvironment.getPjwt();
    
    //console.log(JSON.stringify(resellerId));

    let payload = {
      operation: "cancelCustomerTransfer",
      params: {
        pJwt: aPjwt,
        resellerAccountId: resellerId,
        customerAccountId: acctId
      }
    }
      
    //console.log(JSON.stringify(payload));

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then((response) => {
      return response.json();
    })
    .then(response => {
      // console.log('Account updated')
      this.setState({ forceFetch: forceFetch, showSpinnerCancel: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Assent updated', saveSnackbarDuration: 3000 });
    })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({ forceFetch: forceFetch, showSpinnerCancel: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Assent update failed.', saveSnackbarDuration: null });
    });


  }


  openCCDialog = () => {

    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    let url = '/transferassent';
    localStorage.setItem('paymentReturn', url);


    this.setState({ccOpen: true, showSpinner: false, forceFetch: newForceFetch});

    
  }


  openACHDialog = () => {

    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    let url = '/transferassent';
    localStorage.setItem('paymentReturn', url);
    localStorage.removeItem('plaid');


    this.setState({achOpen: true, showSpinner: false, forceFetch: newForceFetch});

    
  }

  handleACHClose = () => {
    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    localStorage.removeItem('paymentReturn');
    localStorage.removeItem('plaid');

    this.setState({achOpen: false, showSpinner: false, forceFetch: newForceFetch});
  };

  showACHSpinner() {
    return this.state.showACHSpinner;
  }

  handleCCClose = () => {
    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    localStorage.removeItem('paymentReturn');
    this.setState({ccOpen: false, showSpinner: false, forceFetch: newForceFetch});
  };

  showCCSpinner() {
    return this.state.showCCSpinner;
  }

  isACHAllowed(uInfo) {
    if (uInfo.achActive === "0") {
      return false;
    }

    if ((uInfo.firstName === null) || (uInfo.lastName === null) || (uInfo.email === null)) {
      return false;
    }
    return true;
  }

  setDwollaCidOnUInfo = (dwollaCid) => {
    //this is a no op.  They will log on again.
  }

  setStripeCidOnUInfo = (stripeCid) => {
    //this is a no op.  They will log on again.
  }


}

export default withStyles(styles)(TransferAssent);

